"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const ElementDropdown_1 = require("../ElementDropdown");
const Options_module_scss_1 = __importDefault(require("./Options.module.scss"));
function Options({ options, placement, onClick }) {
    const [active, setActive] = (0, react_1.useState)(false);
    return (react_1.default.createElement(ElementDropdown_1.ElementDropdown, { element: react_1.default.createElement("span", null,
            react_1.default.createElement("img", { src: assets_1.svgBasicDragIcon, className: Options_module_scss_1.default.icon, "data-active": active, alt: "" })), placement: placement, dropdown: react_1.default.createElement("div", { className: Options_module_scss_1.default.dropdown }, Object.keys(options).map((option) => {
            return (react_1.default.createElement("div", { className: Options_module_scss_1.default.option, key: option, onClick: () => onClick(option) }, options[option]));
        })), activeStateHandler: setActive }));
}
exports.default = Options;
